import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import BrandExposureContainer from '../../containers/brand/BrandExposureContainer';
import { BRAND_PAGE_NAME, BRAND_PAGE_TYPE } from '../../constants/service/app/brandConstants';

const BrandTopExposure = () => {
  return (
    <PageTemplate pageName={BRAND_PAGE_NAME.BRAND_TOP_EXPOSURE_LIST}>
      <BrandExposureContainer pageType={BRAND_PAGE_TYPE.TOP_EXPOSURE} />
    </PageTemplate>
  );
};

export default BrandTopExposure;
